import {loadSvg} from 'js/utility/image.js'

export default {
    name: 'info-box',

    data: {
        isconSvg: null
    },

    mounted () {
        if (this.icon_url) {
            loadSvg(this.icon_url).then(svg => this.isconSvg = svg.outerHTML)
        }
        if (this.contact_fom_index && this.$refs.button) {
            this.$refs.button.addEventListener('click', e => {
                sessionStorage.setItem('contactFormIndex', this.contact_fom_index)
            })
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/info-box/info-box.js